<div class="skeleton-loader" [ngStyle]="getStyles()">
    <!-- You can use ng-content or specific layout here -->
  </div>
